var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,-1) translate(0 -40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.6 21.6 9.6-9.6 2.8 2.8-12.4 12.4L8.2 14.8 11 12l9.6 9.6Z"
  }))));
};
export default SvgChevronUp;